import {DocumentFieldsFragment, DocumentStatus, DocumentType, Maybe} from 'api/generated';
import {documentTypeLabels} from 'lib/labels';

export const getDocumentName = (document?: Maybe<DocumentFieldsFragment>) => {
  if (!document) return '';
  const type = documentTypeLabels[document.type];
  const showType = ![DocumentType.OTHER, DocumentType.PIBISI_REPORT].includes(document.type);
  return document.name ? (showType ? `${document.name} (${type})` : document.name) : type;
};

export const canBeApproved = (document?: Maybe<DocumentFieldsFragment>) => {
  if (!document) return false;
  return [DocumentStatus.APPROVAL_REQUIRED, DocumentStatus.REJECTED].includes(document.status);
};

export const canBeRejected = (document?: Maybe<DocumentFieldsFragment>) => {
  if (!document) return false;
  return document.status === DocumentStatus.APPROVAL_REQUIRED;
};
